import { LockFilled, GlobalOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React from "react";

export const ConfigPublicStatus: React.FC<{ isPublic?: boolean; where?: "listing" | "other" }> = ({
  isPublic = false,
  where = "listing",
}) => {
  if (isPublic) {
    return (
      <Tooltip title="This is public exploration">
        <GlobalOutlined className="text-blue-500" />
      </Tooltip>
    );
  }

  return (
    <Tooltip title={`This is private exploration. ${where === "other" ? "Click 'Share' to make it public" : ""}`}>
      <LockFilled className="text-gray-500" />
    </Tooltip>
  );
};
